import type { FunctionComponent } from "react";
import { Button } from "../../ui/button";
import { useToast } from "../../../hooks/use-toast";
import { handleHttpError } from "../../../utils/utils";
import Spinner from "../../spinner.components";
import type { ISocial } from "../../../types/models/social.models.types";
import { useParams } from "react-router-dom";
import { useRemoveSocialFromFavoriteCollectionCopyAdminHttp } from "../../../hooks/http/admin/favorites/remove-social-from-favorite-collection-copy.admin.http";

type AppProps = {
	removeById: (id: string) => void;
	social: ISocial;
	className?: string;
};

export const RemoveFromGroup: FunctionComponent<AppProps> = ({
	social,
	removeById,
	className,
}) => {
	const { favoriteId } = useParams();

	const {
        execute: removeSocialFromFavoriteCollectionCopyHttp,
        fetching: fetchingRemoveSocialFromFavoriteCollectionCopy,
    } = useRemoveSocialFromFavoriteCollectionCopyAdminHttp();

	const { toast } = useToast();

	const handleRemoveFromGroup = async () => {
		if (!favoriteId) {
			return;
		}

		const response = await removeSocialFromFavoriteCollectionCopyHttp({
			pathParams: { id: favoriteId },
			body: {
				socials: [social.id],
			},
		});

		if (!response.success) {
			return handleHttpError(response, toast);
		}
		removeById(social.id);
	};

	return (
		<Button
			disabled={fetchingRemoveSocialFromFavoriteCollectionCopy}
			onClick={handleRemoveFromGroup}
			className={`border-rejectbuttonborder w-24 h-10 bg-rejectbuttonbg border font-semibold text-rejectbuttontext tracking-wider ${className}`}
		>
			{fetchingRemoveSocialFromFavoriteCollectionCopy ? (
				<Spinner width={15} />
			) : (
				"remove"
			)}
		</Button>
	);
};
